// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__246t3","unreadBadge":"styles_unreadBadge__3AgyC","modalContent":"styles_modalContent__2XzIf","modal":"styles_modal__kQ6kf"};